// 域名与默认语言映射；域名只决定未手动切换时的默认语言
// 静态 HTML 标题由构建模式决定（.env.en / .env.cn）
const DOMAIN_LOCALE = {
  'www.szcofoe.com': 'en',
  'szcofoe.com': 'en', // 裸域，通常跳转到 www
  'cn.szcofoe.com': 'zh'
}

// 未识别域名返回 null
export function getDomainLocale(hostname) {
  const host = (hostname || window.location.hostname || '').toLowerCase()
  return DOMAIN_LOCALE[host] || null
}
